import { render, staticRenderFns } from "./WechatAccountsView.vue?vue&type=template&id=ff2415e4&scoped=true"
import script from "./WechatAccountsView.vue?vue&type=script&lang=js"
export * from "./WechatAccountsView.vue?vue&type=script&lang=js"
import style0 from "./WechatAccountsView.vue?vue&type=style&index=0&id=ff2415e4&prod&scoped=true&lang=scss"
import style1 from "./WechatAccountsView.vue?vue&type=style&index=1&id=ff2415e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2415e4",
  null
  
)

export default component.exports